import * as React from 'react'
import {createContext, useState} from 'react'

export const SearchContext = createContext({});

export const SearchProvider = (props: any) => {
    const [query, updateQuery] = useState('');
    const properties = {
        query,
        updateQuery,
    };

    return (
        <SearchContext.Provider value={properties}>
            {props.children}
        </SearchContext.Provider>
    )
};